import { Subject } from 'rx';

export default class LocalStreamingLog {

    subject = new Subject();

    topics = new Map(); // Map[String, Observable[String]]

    publish(topic, message) {
        this.subject.onNext({ topic, message });
    }

    getTopic(topic) {
        let ret = this.topics.get(topic);
        if (!ret) {
            ret = this.subject.filter((ev) => ev.topic === topic).map((ev) => ev.message);
            this.topics.set(topic, ret);
        }
        return ret;
    }
}



/** WEBPACK FOOTER **
 ** ./lib/event-bus-rx/LocalStreamingLog.js
 **/